module.exports = __webpack_public_path__ + "static/man-with-phone-6032804a5414fa459b1c90663e258b26.png";